import { TOrganization } from "~/types/user";
import { baseService } from "../base";

export const organizationService = {
  getAll: async () => {
    const { data } = await baseService.get<TOrganization[]>("/organizations");
    return data;
  },
  getOne: async (id: string) => {
    const { data } = await baseService.get<TOrganization>(`/organizations/${id}`);
    return data;
  },
  update: async (id: string, body: Partial<TOrganization>) => {
    const { data } = await baseService.patch<TOrganization>(`/organizations/${id}`, body);
    return data;
  },
};
